import { Box, Typography } from "@mui/material";
import React from "react";
import Vector from "../../assets/SVG/vector";

export default function ButtonNextLevel({
  setLevel,
  justifyContent,
  level,
  onClickNextLevel,
  handleClickBack,
}) {
  return (
    <Box
      display="flex"
      justifyContent={justifyContent ? justifyContent : "center"}
      mt="20px"
    >
      <button
        style={{
          border: "none",
          width: "150px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "white",
          // boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
          padding: "12px 0px",
          marginTop: "20px",
          borderRadius: "8px",
        }}
        onClick={() => {
          setLevel(level - 1);
          if (handleClickBack) handleClickBack();
        }}
      >
        <Box sx={{ transform: "rotate(180deg)", mt: "-4px" }}>
          <Vector color="#E24B4B" />
        </Box>
        <Typography
          fontWeight={"bold"}
          fontSize="14px"
          color="#E24B4B"
          mr="10px"
        >
          مرحله قبل
        </Typography>
      </button>
      <button
        style={{
          border: "none",
          width: "150px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "var(--emr-darkblue)",
          boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
          padding: "12px 0px",
          marginTop: "20px",
          borderRadius: "8px",
        }}
        onClick={() => {
          onClickNextLevel();
          // .then(() => {
          //   setLevel(level + 1);
          // });
        }}
      >
        <Typography fontSize="14px" color="white" ml="10px">
          مرحله بعد
        </Typography>
        <Vector color="white" />
      </button>
    </Box>
  );
}
